import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import { auth, db } from "../firebase/firebase";

function ProtectedRoute({ children, adminOnly = false }) {
  const location = useLocation();

  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!mounted) return;

      if (!firebaseUser) {
        setUser(null);
        setUserData(null);
        setLoading(false);
        return;
      }

      setUser(firebaseUser);

      try {
        const userRef = doc(db, "users", firebaseUser.uid);
        const userSnapshot = await getDoc(userRef);

        if (!mounted) return;

        if (userSnapshot.exists()) {
          setUserData(userSnapshot.data());
        } else {
          setUserData(null);
        }
      } catch (error) {
        console.error("Protected route user lookup error:", error);
        setUserData(null);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  /*
  ============================================================
  AUTH LOADING
  ============================================================
  */

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f6f8fb]">
        <div className="flex flex-col items-center">

          <div className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-[#00a96d] shadow-lg shadow-emerald-500/20">
            <span className="absolute h-6 w-6 animate-spin rounded-full border-2 border-white/30 border-t-white" />
          </div>

          <p className="mt-4 text-xs font-bold text-slate-500">
            Checking your account...
          </p>

        </div>
      </div>
    );
  }

  /*
  ============================================================
  NOT LOGGED IN
  ============================================================
  */

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
        }}
      />
    );
  }

  /*
  ============================================================
  ADMIN ONLY ROUTE
  ============================================================
  */

  if (adminOnly && userData?.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  /*
  ============================================================
  PROTECTED CONTENT
  ============================================================
  */

  return children;
}

export default ProtectedRoute;